import { render, staticRenderFns } from "./PracticeSumupResultRankTab.vue?vue&type=template&id=71353094&scoped=true&"
import script from "./PracticeSumupResultRankTab.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupResultRankTab.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupResultRankTab.vue?vue&type=style&index=0&id=71353094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71353094",
  null
  
)

export default component.exports